import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import axios from "axios";
import StandardButton from "@/components/buttons/StandardButton.vue";
import BigButton from "@/components/buttons/BigButton.vue";
import { alertError } from "@/util/dialog";
import WInput from "@/components/form/w-input.vue";
import AIStepsGenerator from "@/components/aiSpeachGenerator/AIStepsGenerator.vue";
import { waitingJob } from "@/util/job.utils";
import WSelect from "@/components/form/w-select.vue";
import WLink from "@/components/wrappers/w-link.vue";
import WCheckbox from "@/components/form/w-checkbox.vue";
import WText from "@/components/wrappers/w-text.vue";
import AIModePicker from "@/components/aiSpeachGenerator/AIModePicker.vue";
import AIRoleSelector from "@/components/aiSpeachGenerator/AIRoleSelector.vue";
import AIScenarioSelector from "@/components/aiSpeachGenerator/AIScenarioSelector.vue";
import AIStyleStep from "@/components/aiSpeachGenerator/AIStyleStep.vue";
import { ContentMode } from "@/models/ai/enum/aiContentMode.enum";
import { SlideGenerationMode } from "@/util/generationModeEnum";
import { listOfLanguage } from "@/util/langUtils";
import { getDoc2SpeachAllowedExtensions } from "@/util/fileUtil";
let AISpeachGenerator = class AISpeachGenerator extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "weetEndpoint", void 0);
    _defineProperty(this, "fullContentGeneration", void 0);
    _defineProperty(this, "initFilesJson", void 0);
    _defineProperty(this, "vision", void 0);
    _defineProperty(this, "advancedTts", void 0);
    _defineProperty(this, "linkId", void 0);
    // DEMO_MODE / MAX_SPEACH_PER_USER: when the user hit the per-user speach cap, the creator shows a
    // "limit reached" screen instead of the upload wizard.
    _defineProperty(this, "speachLimitReached", void 0);
    _defineProperty(this, "speachLimit", void 0);
    // DEMO_MODE (confined user): the plan-review screen only offers "Generate all" (no save & edit).
    _defineProperty(this, "demoMode", void 0);
    // AI_AVATAR_CUSTOM allow-list (e.g. "ANDY;MORGAN"). Gates custom avatars (Dana, Andy...) in the
    // style step's avatar picker — same conf the weet recorder uses.
    _defineProperty(this, "avatarCustom", void 0);
    _defineProperty(this, "step", 0);
    _defineProperty(this, "uploadInProgress", false);
    _defineProperty(this, "listOfUserFile", []);
    _defineProperty(this, "proceededFile", []);
    _defineProperty(this, "initFilesObj", []);
    _defineProperty(this, "durationSelected", '');
    _defineProperty(this, "allowReorder", true);
    _defineProperty(this, "specificPrompt", '');
    _defineProperty(this, "generationmode", SlideGenerationMode.ENHANCED);
    // Default layout = MIXED (avatar + slides + video explainer). ENHANCED generation mode pairs with it.
    _defineProperty(this, "contentMode", ContentMode.MIXED);
    // false = plan review phase, true = generation phase (emitted by AIStepsGenerator).
    _defineProperty(this, "generationPhase", false);
    _defineProperty(this, "languageSelected", "");
    _defineProperty(this, "visionEnabled", false);
    // Role-based microlearning — kept on the parent so back-navigation preserves data.
    _defineProperty(this, "pickerMode", null);
    _defineProperty(this, "selectedRoles", []);
    _defineProperty(this, "selectedScenario", null);
    _defineProperty(this, "oldDocumentJobID", "");
    _defineProperty(this, "newDocumentJobID", "");
    // Style step (step 5) — kept on the parent so back-navigation preserves data.
    _defineProperty(this, "styleUseAvatar", true);
    _defineProperty(this, "styleAvatar", null);
    _defineProperty(this, "styleBackground", null);
    _defineProperty(this, "styleVoice", null);
    _defineProperty(this, "styleImageStyle", null);
    _defineProperty(this, "styleVisualTemplate", null);
    _defineProperty(this, "styleExplainerEnabled", false);
    _defineProperty(this, "styleQuizEnabled", true);
    _defineProperty(this, "styleAnnotationsEnabled", false);
    // Full Video Explainer content mode → every subchapter is a video explainer.
    _defineProperty(this, "styleFullExplainer", false);
  }
  get isLimitReached() {
    return this.speachLimitReached === 'true';
  }
  contactSupport() {
    window.open('https://speach.me/demo', '_blank');
  }
  get isAllFileProceed() {
    if (this.proceededFile.length === 0) {
      return false;
    }
    for (const file of this.proceededFile) {
      if (!file.data) {
        return false;
      }
    }
    return true;
  }
  get acceptedFileTypes() {
    return getDoc2SpeachAllowedExtensions(this.visionEnabled);
  }
  get listOfLanguageOptions() {
    const list = listOfLanguage(this.$t);
    list.unshift({
      value: '',
      label: this.$t('aiSpeachGenerator.options.languages.placeholder')
    });
    return list;
  }
  mounted() {
    this.proceededFile = [];
    this.durationSelected = this.$t('aiSpeachGenerator.options.durations.short');
    this.initFilesObj = JSON.parse(this.initFilesJson);
    this.visionEnabled = this.vision === "true";
    if (this.initFilesObj.length > 0) {
      this.initWithFile();
    }
  }
  onFileChange() {
    // wait change finalize
    this.$nextTick(() => {
      for (let fileToUpload of this.listOfUserFile) {
        // check if document already proceed
        if (!this.proceededFile.find(el => {
          return el.uid + "" === fileToUpload.uid + "";
        })) {
          // proceed the file
          this.uploadAFile(fileToUpload);
        }
      }
    });
  }
  /** Wizard stepper items (fixed). Role + Scenario stay under the "Type" step. */
  get stepperItems() {
    return [{
      key: 'upload',
      label: this.$t('aiSpeachGenerator.stepper.upload')
    }, {
      key: 'type',
      label: this.$t('aiSpeachGenerator.stepper.type')
    }, {
      key: 'style',
      label: this.$t('aiSpeachGenerator.stepper.style')
    }, {
      key: 'plan',
      label: this.$t('aiSpeachGenerator.stepper.planGeneration')
    }, {
      key: 'generation',
      label: this.$t('aiSpeachGenerator.stepper.generation')
    }];
  }
  /** Maps the internal `step` to the stepper index. Role/scenario stay on "Type". */
  get currentStepperIndex() {
    switch (this.step) {
      case 0:
        return 0;
      // upload
      case 1: // type
      case 2: // role selection — still under "Type"
      case 3:
        return 1;
      // scenario selection — still under "Type"
      case 4:
        return 2;
      // style
      case 6:
        return this.generationPhase ? 4 : 3;
      // plan review vs generation
      default:
        return 0;
    }
  }
  validateUploadDocument() {
    // Step 1 = mode picker (static, no LLM).
    this.step = 1;
  }
  onModeSelected(payload) {
    this.pickerMode = payload.mode;
    this.oldDocumentJobID = payload.oldDocumentJobID || "";
    this.newDocumentJobID = payload.newDocumentJobID || "";
    if (payload.mode === 'ROLE') {
      // Branch into role selection → scenario selection sub-flow.
      this.step = 2;
    } else {
      // ALL_CONTENT / SYNTHESIS / COMPARISON → straight to options step.
      this.specificPrompt = this.buildSpecificPrompt();
      this.step = 4;
    }
  }
  onModePickerBack() {
    this.step = 0;
  }
  onRolesSelected(roles) {
    this.selectedRoles = roles;
    this.step = 3;
  }
  onRoleSelectorBack() {
    this.step = 1;
  }
  onScenarioSelected(scenario) {
    this.selectedScenario = scenario;
    this.specificPrompt = this.buildSpecificPrompt();
    this.step = 4;
  }
  onScenarioSelectorBack() {
    this.step = 2;
  }
  onStyleValidated(payload) {
    this.styleUseAvatar = payload.useAvatar;
    this.styleAvatar = payload.avatar;
    this.styleBackground = payload.background;
    this.styleVoice = payload.voice;
    this.styleImageStyle = payload.imageStyle;
    this.styleVisualTemplate = payload.visualTemplate;
    this.styleExplainerEnabled = payload.explainerEnabled;
    this.styleQuizEnabled = payload.quizEnabled;
    this.styleAnnotationsEnabled = payload.annotationsEnabled;
    this.styleFullExplainer = payload.fullExplainer;
    this.generationPhase = false; // enter step 6 on the plan-review phase
    this.step = 6;
  }
  onGenerationPhase(inGeneration) {
    this.generationPhase = inGeneration;
  }
  onStepsGeneratorBack() {
    this.step = 4; // back to the style/options step
  }
  onStyleBack() {
    // Back depends on which path the user took (role vs non-role).
    if (this.pickerMode === 'ROLE') {
      this.step = 3;
    } else {
      this.step = 1;
    }
  }
  /**
   * Builds the auto-generated `specificPrompt` based on the picker mode + selections.
   * Pre-fills the textarea on the options step so the user can review and edit
   * before the plan is generated.
   */
  buildSpecificPrompt() {
    switch (this.pickerMode) {
      case 'ALL_CONTENT':
        return '';
      case 'SYNTHESIS':
        return this.$t('aiSpeachGenerator.autoPrompts.synthesis');
      case 'COMPARISON':
        {
          const oldName = this.findFileName(this.oldDocumentJobID);
          const newName = this.findFileName(this.newDocumentJobID);
          return this.$t('aiSpeachGenerator.autoPrompts.comparison', {
            oldDoc: oldName,
            newDoc: newName
          });
        }
      case 'ROLE':
        {
          if (!this.selectedScenario || this.selectedRoles.length === 0) return '';
          const rolesList = this.selectedRoles.map(r => r.title).join(', ');
          const description = this.selectedScenario.description || this.selectedScenario.title;
          return this.$t('aiSpeachGenerator.autoPrompts.role', {
            roles: rolesList,
            title: this.selectedScenario.title,
            description
          });
        }
      default:
        return '';
    }
  }
  findFileName(jobID) {
    const file = this.proceededFile.find(f => f.jobID === jobID);
    return file?.name || jobID;
  }
  initWithFile() {
    for (const initFile of this.initFilesObj) {
      const currentFile = {
        uid: initFile.value + "",
        jobID: "",
        name: initFile.label,
        progress: 0,
        data: null
      };
      this.proceededFile.push(currentFile);
      const formData = new FormData();
      formData.append('fileID', initFile.value);
      formData.append('filename', initFile.label);
      axios.post('/recorder/aiSpeachGenerator/extractDocuments', formData).then(async resp => {
        currentFile.jobID = resp.data;
        await this.waitDocumentProceed(currentFile, resp.data, initFile.name + "");
      });
    }
  }
  uploadAFile(fileToUpload) {
    this.proceededFile.push({
      uid: fileToUpload.uid + "",
      jobID: "",
      name: fileToUpload.name,
      progress: 0,
      data: null
    });
    const formData = new FormData();
    const nameOfFile = fileToUpload.raw?.name;
    const currentFile = this.proceededFile.find(el => {
      return fileToUpload.uid + "" === el.uid;
    });
    if (!currentFile) {
      return;
    }
    formData.append('file', fileToUpload.raw, nameOfFile);
    axios.post('/recorder/aiSpeachGenerator/extractDocuments', formData, {
      onUploadProgress: progressEvent => {
        currentFile.progress = Math.round(progressEvent.loaded * 100 / (progressEvent.total || 1));
      }
    }).then(async resp => {
      if (!this.proceededFile.find(el => el.uid === currentFile.uid)) {
        return;
      }
      currentFile.jobID = resp.data;
      await this.waitDocumentProceed(currentFile, resp.data, nameOfFile + "");
    }).catch(err => {
      if (!this.proceededFile.find(el => el.uid === currentFile.uid)) {
        return;
      }
      currentFile.progress = -1;
      alertError(err);
    });
  }
  async waitDocumentProceed(currentFile, jobID, name) {
    try {
      const data = await waitingJob(jobID);
      // Find the file in proceededFile based on uid
      const fileIndex = this.proceededFile.findIndex(el => el.uid === currentFile.uid);
      if (fileIndex === -1) {
        // file was removed by the user
        return;
      }
      currentFile.data = data;
      currentFile.progress = 100;
      // Remove and re-add to trigger Vue reactivity
      this.proceededFile.splice(fileIndex, 1);
      this.proceededFile.push(currentFile);
    } catch (e) {
      if (!this.proceededFile.find(el => el.uid === currentFile.uid)) {
        return;
      }
      alertError("Something wrong on your file: " + name);
    }
  }
  removeFile(file) {
    this.proceededFile = this.proceededFile.filter(el => el.uid !== file.uid);
    this.listOfUserFile = this.listOfUserFile.filter(el => el.uid + "" !== file.uid);
  }
  onDurationChange(value) {
    this.durationSelected = value;
  }
  onLanguageChange(value) {
    this.languageSelected = value;
  }
  onAllowReorder(value) {
    this.allowReorder = value;
  }
  onSpecificPromptChange(value) {
    this.specificPrompt = value;
  }
  onGenerationModeChange(value) {
    this.generationmode = value;
  }
  onContentModeChange(value) {
    this.contentMode = value;
  }
};
__decorate([Prop({
  required: true
})], AISpeachGenerator.prototype, "weetEndpoint", void 0);
__decorate([Prop({
  default: ''
})], AISpeachGenerator.prototype, "fullContentGeneration", void 0);
__decorate([Prop({
  default: false
})], AISpeachGenerator.prototype, "initFilesJson", void 0);
__decorate([Prop({
  default: ''
})], AISpeachGenerator.prototype, "vision", void 0);
__decorate([Prop({
  default: ''
})], AISpeachGenerator.prototype, "advancedTts", void 0);
__decorate([Prop({
  default: ''
})], AISpeachGenerator.prototype, "linkId", void 0);
__decorate([Prop({
  default: 'false'
})], AISpeachGenerator.prototype, "speachLimitReached", void 0);
__decorate([Prop({
  default: '0'
})], AISpeachGenerator.prototype, "speachLimit", void 0);
__decorate([Prop({
  default: 'false'
})], AISpeachGenerator.prototype, "demoMode", void 0);
__decorate([Prop({
  default: ''
})], AISpeachGenerator.prototype, "avatarCustom", void 0);
AISpeachGenerator = __decorate([Component({
  components: {
    AIModePicker,
    AIRoleSelector,
    AIScenarioSelector,
    AIStyleStep,
    WText,
    WCheckbox,
    WLink,
    WSelect,
    AIStepsGenerator,
    WInput,
    BigButton,
    StandardButton,
    Icon
  }
})], AISpeachGenerator);
export default AISpeachGenerator;